<template>
    <aside class="menu">
        <section>
            <p class="menu-label">Rum</p>
            <ul class="menu-list" v-if="rooms">
                <router-link :to="{ name: 'Room', params: { title: room.title }}" tag="li" v-for="(room,key) in rooms"
                             :key="key">
                    <a>{{room.title}}</a>
                </router-link>
            </ul>
        </section>
        <section>
            <p class="menu-label">Övrigt</p>
            <ul class="menu-list">
                <li>
                    <router-link :to="{name: 'Schools'}" tag="li"><a>Skolor</a></router-link>
                </li>
                <li>
                    <a class="nav-link" v-on:click="$emit('logout')"><i class="fa fa-lock"></i> Logout</a>
                </li>
            </ul>
        </section>
    </aside>

</template>

<script>
export default {
  name: 'LeftMenu',
  data () {
    return {}
  },
  computed: {
    rooms: function () {
      return this.$store.state.data.Rooms
    },
    other: function () {
      return this.$store.state.data.Other
    },
    routes: function () {
      const routes = {
        default: []
      }
      for (const i in this.$router.options.routes) {
        if (!this.$router.options.routes.hasOwnProperty(i)) {
          continue
        }
        const route = this.$router.options.routes[i]

        if (route.hasOwnProperty('name') && route.hasOwnProperty('meta') && route.meta.hasOwnProperty('inMenu') && route.meta.inMenu) {
          if (route.meta.hasOwnProperty('group')) {
            if (!routes.hasOwnProperty(route.meta.group)) {
              routes[route.meta.group] = []
            }
            routes[route.meta.group].push(route)
          } else {
            routes.default.push(route)
          }
        }
      }
      return routes
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
